import { Component, Input } from '@angular/core';

@Component({
  selector: 'evsb-price-list-entry',
  templateUrl: './price-list-entry.component.html',
})
export class EvsbPriceListEntryComponent {
  @Input() label: string;
  @Input() count: number;
  @Input() price: number;
  @Input() description: number;
  @Input() bottomLabel: number;
}
